document.addEventListener("DOMContentLoaded", () => {
    const tabs = document.querySelectorAll(".BlogTabcontainer .tab");
    const contents = document.querySelectorAll(".BlogTabcontainer .content");
  
    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        // Remove active classes
        tabs.forEach((t) => t.classList.remove("active"));
        contents.forEach((c) => c.classList.remove("active"));
  
        // Add active classes to the clicked tab and corresponding content
        tab.classList.add("active");
        const target = document.getElementById(tab.dataset.tab);
        target.classList.add("active");
      });
    });
  });




  document.addEventListener("DOMContentLoaded", () => {
    const buttons = document.querySelectorAll(".tab-button");
    const contents = document.querySelectorAll(".tab-content");
  
    buttons.forEach(button => {
      button.addEventListener("click", () => {
        const targetTab = button.getAttribute("data-tab");
  
        // Remove active class from all buttons and contents
        buttons.forEach(btn => btn.classList.remove("active"));
        contents.forEach(content => content.classList.remove("active"));
  
        // Add active class to clicked button and target content
        button.classList.add("active");
        document.getElementById(targetTab).classList.add("active");
      });
    });
  });
  












// Add event listeners to all play/pause and mute/unmute buttons
document.querySelectorAll('.play-pause').forEach((button) => {
    button.addEventListener('click', () => {
        const video = button.closest('.controls').previousElementSibling; // Select the corresponding video
        const playPauseIcon = button.querySelector('img');

        if (video.paused) {
            video.play();
            playPauseIcon.src = "https://cdn.shopify.com/s/files/1/0911/5002/5007/files/pause_e1b30799-15af-471c-ac13-97963e1150bd.png?v=1736011325"; // Update icon to 'pause'
            playPauseIcon.alt = "pause button";
        } else {
            video.pause();
            playPauseIcon.src = "https://cdn.shopify.com/s/files/1/0911/5002/5007/files/play-buttton.png?v=1736011325"; // Update icon to 'play'
            playPauseIcon.alt = "play button";
        }
    });
});

document.querySelectorAll('.muteUnmute').forEach((button) => {
    button.addEventListener('click', () => {
        const video = button.closest('.controls').previousElementSibling; // Select the corresponding video
        const muteUnmuteIcon = button.querySelector('img');

        if (video.muted) {
            video.muted = false;
            muteUnmuteIcon.src = "https://cdn.shopify.com/s/files/1/0911/5002/5007/files/volume.png?v=1736011325"; // Update icon to 'mute'
            muteUnmuteIcon.alt = "mute button";
        } else {
            video.muted = true;
            muteUnmuteIcon.src = "https://cdn.shopify.com/s/files/1/0911/5002/5007/files/mute.png?v=1736011325"; // Update icon to 'unmute'
            muteUnmuteIcon.alt = "unmute button";
        }
    });
});







// Add event listeners to all blurred buttons
// Add event listeners to all blurred buttons
// document.querySelectorAll('.blurred-button').forEach((button) => {
//     button.addEventListener('click', () => {
//         // const video = button.closest('.controls').previousElementSibling; 
//       // Select the corresponding video
//           const video = document.querySelectorAll('.custom-video');
//         if (video.requestFullscreen) {
//             video.requestFullscreen(); // Standard method
//         } else if (video.webkitRequestFullscreen) {
//             video.webkitRequestFullscreen(); // Safari
//         } else if (video.msRequestFullscreen) {
//             video.msRequestFullscreen(); // Internet Explorer/Edge
//         }
//     });
// });


// Add event listener to all blurred buttons
document.querySelectorAll('.blurred-button').forEach((button) => {
    button.addEventListener('click', () => {
        const video = button.closest('.blogBannerBtnWrap').previousElementSibling.querySelector('.custom-video'); // Select the corresponding video

        // Check for Fullscreen API compatibility and request fullscreen
        if (video.requestFullscreen) {
            video.requestFullscreen();
        } else if (video.webkitRequestFullscreen) { // Safari
            video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) { // Internet Explorer/Edge
            video.msRequestFullscreen();
        }
    });
});

// Exit fullscreen on 'Esc' key press
document.addEventListener('fullscreenchange', () => {
    if (!document.fullscreenElement) {
        console.log('Exited fullscreen'); // Optional debug log
    }
});

// Compatibility for WebKit (Safari)
document.addEventListener('webkitfullscreenchange', () => {
    if (!document.webkitFullscreenElement) {
        console.log('Exited fullscreen'); // Optional debug log
    }
});

// Compatibility for MS (Internet Explorer/Edge)
document.addEventListener('msfullscreenchange', () => {
    if (!document.msFullscreenElement) {
        console.log('Exited fullscreen'); // Optional debug log
    }
});




